import React, { useState, useEffect } from "react";
import { imgs } from "./imgs"; // adjust path

export default function ItemLookup() {
  const [searchId, setSearchId] = useState("");
  const [foundItem, setFoundItem] = useState(null);
  const [show, setShow] = useState(false);

  const handleSearch = () => {
    const item = imgs.find((img) => img.id === searchId.trim());
    setFoundItem(item || null);
  };

  useEffect(() => {
    const storedEmail = localStorage.getItem("userEmail");
    // console.log(storedEmail);
    if (storedEmail === process.env.REACT_APP_ADMIN_KEY) {
      setShow(true);
    }
  }, []);

  return (
    <>
    
      {show ? (
        <div className="p-6 max-w-xl mx-auto">
          <h2 className="text-xl font-bold mb-4">Find Item by ID</h2>

          {/* Input and Button */}
          <div className="flex gap-2 mb-4">
            <input
              type="text"
              value={searchId}
              onChange={(e) => setSearchId(e.target.value)}
              placeholder="Enter ID (e.g., W&W-1)"
              className="border rounded px-3 py-2 flex-1"
            />
            <button
              onClick={handleSearch}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Search
            </button>
          </div>

          {/* Show Item Info */}
          {foundItem ? (
            <div className="border rounded p-4 bg-gray-50">
              <img
                src={foundItem.src}
                alt={foundItem.alt}
                className="w-32 h-32 object-contain mb-3"
              />
              <p><strong>ID:</strong> {foundItem.id}</p>
              <p><strong>Alt:</strong> {foundItem.alt}</p>
              <p><strong>Extension:</strong> {foundItem.extension}</p>
              <p><strong>Available:</strong> {foundItem.available.join(", ")}</p>
              <p><strong>Folder:</strong> {foundItem.folder || "N/A"}</p>
              <p><strong>Full Path:</strong> {foundItem.full_path}</p>
              <p><strong>Size:</strong> {foundItem.size}</p>
              <p><strong>Price:</strong> ${foundItem.price}</p>
            </div>
          ) : (
            searchId && (
              <p className="text-red-500">No item found with that ID.</p>
            )
          )}
        </div>
      ) : null}
    </>
  );
}
